import React from "react";
import {
    Card,
    Row,
    Button,
    Dropdown,
    Container,
    Col
} from "react-bootstrap";
import { connect } from "react-redux";
function DetailsView({
    onBack,
    User
}) {
    return (
        <React.Fragment>
            <Button
                className="btn btn-primary my-1"
                onClick={onBack}
                title="Go back"
            >
                <i className="bi bi-arrow-left"></i> Back
            </Button>
            <Card className="cards">
                <Card.Body>
                    <Container>
                        <Row className="g-3">
                            <Col xs={12} md={6}>
                                <div>
                                    <strong> Username:</strong> {User.Username}
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div>
                                    <strong> Email:</strong> {User.Email}
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div>
                                    <strong> Role:</strong> {User.RoleName}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {};
}
export default connect(mapStateToProps, null)(DetailsView);